/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";

/**
 * exclude the LatestStatusValidationMixin for root users
 * @export
 * @interface PatchedTimedSavedStateUpdate
 */
export interface PatchedTimedSavedStateUpdate {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  readonly simulation?: string | null;
  /**
   *
   */
  created?: Date | null;
  /**
   * Time in simulation the savedstate has been created
   */
  createdTime?: number | null;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
  /**
   *
   */
  expiry?: Date | null;
  /**
   * Time in simulation to create savedstate
   */
  time?: number | null;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  uuid?: string;
}

/**
 * Check if a given object implements the PatchedTimedSavedStateUpdate interface.
 */
export function instanceOfPatchedTimedSavedStateUpdate(
  value: object
): value is PatchedTimedSavedStateUpdate {
  return true;
}

export function PatchedTimedSavedStateUpdateFromJSON(json: any): PatchedTimedSavedStateUpdate {
  return PatchedTimedSavedStateUpdateFromJSONTyped(json, false);
}

export function PatchedTimedSavedStateUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedTimedSavedStateUpdate {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"] == null ? undefined : json["name"],
    simulation:
      json["simulation"] === undefined
        ? undefined
        : json["simulation"] === null
        ? null
        : json["simulation"],
    created:
      json["created"] === undefined
        ? undefined
        : json["created"] === null
        ? null
        : parseDateTime(json["created"]),
    createdTime:
      json["created_time"] === undefined
        ? undefined
        : json["created_time"] === null
        ? null
        : json["created_time"],
    tags: json["tags"] == null ? undefined : json["tags"],
    expiry:
      json["expiry"] === undefined
        ? undefined
        : json["expiry"] === null
        ? null
        : parseDateTime(json["expiry"]),
    time: json["time"] === undefined ? undefined : json["time"] === null ? null : json["time"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    id: json["id"] == null ? undefined : json["id"],
    uuid: json["uuid"] == null ? undefined : json["uuid"],
  };
}

export function PatchedTimedSavedStateUpdateToJSON(json: any): PatchedTimedSavedStateUpdate {
  return PatchedTimedSavedStateUpdateToJSONTyped(json, false);
}

export function PatchedTimedSavedStateUpdateToJSONTyped(
  value?: Omit<PatchedTimedSavedStateUpdate, "url" | "simulation" | "file" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    created_time: value["createdTime"],
    tags: value["tags"],
    expiry: value["expiry"] == null ? value["expiry"] : serializeDateTime(value["expiry"]),
    time: value["time"],
    uuid: value["uuid"],
  };
}
